export const NOTE_CATEGORIES = ["General", "Estimation", "Design", "Quote-Invoice"];

export const DEFAULT_NOTE_CATEGORY = "General";

const NOTE_CATEGORY_BADGE_CLASSES = {
    "General": "bg-gray-100 text-gray-700",
    "Estimation": "bg-blue-100 text-blue-700",
    "Design": "bg-red-100 text-red-700",
    "Quote-Invoice": "bg-green-100 text-green-700",
};

export const getNoteCategoryBadgeClasses = (category) =>
    NOTE_CATEGORY_BADGE_CLASSES[category] || NOTE_CATEGORY_BADGE_CLASSES[DEFAULT_NOTE_CATEGORY];
